document.addEventListener("DOMContentLoaded", function () {

  // Selecciona el input de búsqueda y el contenedor de resultados
  const searchInput = document.getElementById("search-input");
  const resultsContainer = document.getElementById("search-results");

  // Si alguno de los elementos no existe, se termina la ejecución
  if (!searchInput || !resultsContainer) return;

  let controller = null; // Usado para cancelar peticiones anteriores
  let currentQueryId = 0; // ID incremental para identificar cada búsqueda y evitar mostrar resultados atrasados

  // Escucha el evento de entrada en el campo de búsqueda
  searchInput.addEventListener("input", function () {
    const query = searchInput.value.trim(); // Obtiene el valor ingresado sin espacios
    
    // Si hay menos de 2 caracteres, oculta resultados
    if (query.length < 2) {
      resultsContainer.innerHTML = "";
      resultsContainer.style.display = "none";
      return;
    }

    // Cancela cualquier búsqueda anterior aún en proceso
    if (controller) controller.abort();
    controller = new AbortController();
    const signal = controller.signal;

    const thisQueryId = ++currentQueryId; // Asigna un ID único a esta búsqueda

    // Llama al endpoint de sugerencias de Shopify
    fetch(`/search/suggest.json?q=${query}&resources[type]=product`, { signal })
      .then(response => response.json())
      .then(data => {
        // Si esta búsqueda ya fue superada por una nueva, se ignora
        if (thisQueryId !== currentQueryId) return;

        resultsContainer.innerHTML = "";

        // Si hay productos sugeridos
        if (data.resources.results.products.length > 0) {
          resultsContainer.style.display = "block";

          // Mapea cada producto para obtener sus variantes desde el archivo .js
          const variantFetches = data.resources.results.products.map(product =>
            fetch(`/products/${product.handle}.js`)
              .then(response => response.json())
              .then(productData => {
                // Si esta búsqueda ya fue reemplazada, se detiene
                if (thisQueryId !== currentQueryId) return; // Ignore old fetches

                if (productData.variants && productData.variants.length > 0) {
                  productData.variants.forEach(variant => {
                  const isDefault = variant.title.toLowerCase() === "default title";

                  // Crea el elemento visual para cada variante del producto
                  const li = document.createElement("li");
                  li.innerHTML = `
                    <a href="/products/${product.handle}${isDefault ? "" : `?variant=${variant.id}`}" class="search-result-item">
                      <img src="${product.image}" alt="${product.title}${isDefault ? "" : " - " + variant.title}" class="search-result-img">
                      <span>${product.title}${isDefault ? "" : " - " + variant.title}</span>
                    </a>`;
                  resultsContainer.appendChild(li);
                  });
                } else {
                  // Si no hay variantes, se muestra el producto directamente
                  const li = document.createElement("li");
                  li.innerHTML = `
                    <a href="${product.url}" class="search-result-item">
                      <img src="${product.image}" alt="${product.title}" class="search-result-img">
                      <span>${product.title}</span>
                    </a>`;
                  resultsContainer.appendChild(li);
                }
              })
          );
          
          // Espera a que terminen todos los fetches de variantes (opcionalmente útil para validaciones adicionales)
          Promise.all(variantFetches).catch(err => {
            if (err.name !== "AbortError") {
              console.error("Error al obtener variantes:", err);
            }
          });

        // Si no hay resultados, se oculta el contenedor
        } else {
          resultsContainer.style.display = "none";
        }
      })
      .catch(error => {
        if (error.name !== "AbortError") {
          console.error("Error en la búsqueda:", error);
        }
      });
  });

  // Oculta los resultados si se hace clic fuera del input o del contenedor
  document.addEventListener("click", function (event) {
    if (!searchInput.contains(event.target) && !resultsContainer.contains(event.target)) {
      resultsContainer.style.display = "none";
    }
  });
});